// components/chi/ChiHowToUseSlider.jsx
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { COLORS } from "constants/colors";

import {
  SunIcon,
  EarthIcon,
  JupiterIcon,
  SaturnIcon,
  VenusIcon,
  MercuryIcon,
  MoonIcon,
} from "./PlanetIcons";

const howToItems = [
  {
    point: "Point 1",
    title: "あなたが何者かは\nあなたが決める",
    description:
      "あなた自身として接するか\n作品世界の人になり切るかは\nあなたが決める.",
    // icon: <SunIcon sx={{ fontSize: 40, color: 'white' }} />
  },
  // {
  //   point: "Point 2",
  //   title: "あなたのチャットは\nキャラの心に届いている",
  //   description: "キャラが心であなたに\n向けて話したことが\nチャットに送られている",
  //   icon: <MercuryIcon sx={{ fontSize: 36, color: 'white' }} />
  // },
  {
    point: "Point 2",
    title: "地動説について話す前に\nキャラの信頼を得る",
    description: "「あなたが何者か」\n「キャラにどう接するか」\nが重要.",
    // icon: <EarthIcon sx={{ fontSize: 36, color: 'white' }} />
  },
  {
    point: "Point 3",
    title: "キャラの信頼を\n得る方法",
    description: "1. 日々の会話を大事にする\n2. クエストをクリアする",
    // icon: <SaturnIcon sx={{ fontSize: 36, color: 'white' }} />
  },
  {
    point: "Point 4",
    title: "キャラは離席する",
    description:
      "キャラは話の途中で離席することがある.\n信頼されると長く話せる可能性が高い.",
    // icon: <JupiterIcon sx={{ fontSize: 32, color: 'white' }} />
  },
  {
    point: "Point 5",
    title: "リセット",
    description:
      "関係がうまくいかない時,\n別の関係を築きたい時などに\nリセットで最初からやり直せる.",
    // icon: <MoonIcon sx={{ fontSize: 32, color: 'white' }} />
  },
];

export default function ChiHowToUseSlider() {
  const { t, i18n } = useTranslation(["chi"]);
  const howToUseItems = t("chi:HowToUseItems", { returnObjects: true });
  const isThai = (i18n.resolvedLanguage || i18n.language || "").startsWith(
    "th"
  );
  return (
    <Box sx={{ width: "100%", maxWidth: 420 }}>
      <Swiper
        pagination={{ clickable: true }}
        modules={[Pagination]}
        spaceBetween={30}
        slidesPerView={1}
        style={{
          "--swiper-pagination-color": COLORS.TEXT_WHITE, // アクティブ
          "--swiper-pagination-bullet-inactive-color": COLORS.TEXT_GRAY, // 非アクティブ
          "--swiper-pagination-bullet-inactive-opacity": "1",
          "--swiper-pagination-bullet-size": "6px",
          "--swiper-pagination-bullet-horizontal-gap": "2px",
        }}
      >
        {/* howToItems.map((item, index) => (*/}
        {howToUseItems.map((item, index) => (
          <SwiperSlide key={index}>
            <Box
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 2,
                padding: 3,
                textAlign: "center",
                border: `1px solid ${COLORS.TEXT_WHITE}`,
                borderRadius: 2,
                minHeight: "350px",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                color: COLORS.TEXT_WHITE,
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: isThai ? 500 : "bold",
                  fontFamily: '"Noto Serif JP", serif',
                }}
              >
                {item.point}
              </Typography>

              <Box
                sx={{
                  width: "100%",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "19px",
                    fontWeight: isThai ? 500 : "bold",
                    marginY: 2,
                    fontFamily: '"Noto Serif JP", serif',
                    whiteSpace: "pre-line",
                    lineHeight: 2.0,
                  }}
                >
                  {item.title}
                </Typography>
              </Box>

              {item.icon}

              <Box
                sx={{
                  width: "90%",
                  paddingY: 3,
                  borderRadius: 1,
                  marginY: 2,
                  backgroundColor: "rgba(255, 255, 255, 0.05)",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontFamily: '"Noto Serif JP", serif',
                    whiteSpace: "pre-line",
                    lineHeight: 1.8,
                  }}
                >
                  {item.description}
                </Typography>
              </Box>
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
}
